/**
 * Executes sync-delivered commands. Unsupported / reserved types fail honestly.
 */
export async function runDeviceCommands(commands, handlers) {
    const results = [];
    for (const command of commands) {
        let result;
        try {
            switch (command.type) {
                case 'SYNC_NOW':
                    await handlers.syncNow?.();
                    result = { status: 'EXECUTED' };
                    break;
                case 'CLEAR_CACHE':
                    if (!handlers.clearCache) {
                        result = { status: 'FAILED', message: 'CLEAR_CACHE not supported on this surface' };
                        break;
                    }
                    await handlers.clearCache();
                    result = { status: 'EXECUTED' };
                    break;
                case 'RESTART_PLAYER':
                    if (!handlers.restartPlayer) {
                        result = { status: 'FAILED', message: 'RESTART_PLAYER not supported on this surface' };
                        break;
                    }
                    await handlers.restartPlayer();
                    result = { status: 'EXECUTED' };
                    break;
                default:
                    result = {
                        status: 'FAILED',
                        message: `Unsupported command type: ${command.type}`,
                    };
            }
        }
        catch (error) {
            result = {
                status: 'FAILED',
                message: error instanceof Error ? error.message : 'Command failed',
            };
        }
        results.push({ commandId: command.id, result });
    }
    return results;
}
//# sourceMappingURL=runner.js.map